export default function Result() {
  <h5>Result</h5>;
}
